module.exports = __webpack_public_path__ + "img/7.9f6b45ce.png";